import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryQuickLinks() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            探索漫画世界
          </h2>
          <p className="text-foreground-600 mt-3 text-base">
            国漫、日漫、韩漫，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative p-6 rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 flex flex-col items-center text-center"
            >
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110 ${
                cat.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-base mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}